<template>
    <form @submit.prevent="submitForm">
        <ValidationObserver v-slot="{ invalid, errors }">

            <ValidationProvider name="Email adres" rules="required|email" v-slot="{ errors }" class="flex-grow-1">
                <div class="form-group">
                    <label for="input-name" class="form-control-label">Emailadres</label>
                    <div class="input-group">
                        <div class="input-group-prepend">
                        <span class="input-group-text">
                            <icon name="inbox"></icon>
                        </span>
                        </div>
                        <input
                            type="text"
                            v-model="formValues.email"
                            class="form-control"
                            id="input-email"
                            placeholder="Vul uw e-mailadres in"
                            :class="{ 'is-invalid': errors.length }"
                            required />
                        <div v-if="errors.length" class="invalid-feedback">{{ errors[0] }}</div>
                    </div>
                </div>
            </ValidationProvider>

        </ValidationObserver>
    </form>
</template>

<script>

    import { ValidationProvider, ValidationObserver } from 'vee-validate';

    export default {
        name: 'ForgotPasswordForm',

        components: {
            ValidationProvider,
            ValidationObserver,
        },

        data() {
            return {
                formValues: {
                    email: '',
                },
            };
        },
        methods: {
            submitForm() {
                this.$emit('submit', this.formValues);
            },
        },
    };
</script>
